import { memo } from "react";
import { Platform, Pressable } from "react-native";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View } from "@src/components";
import { Icon } from "@src/components/Icon";
import { Text } from "@src/components/Text";
import Logo from "@src/assets/svgs/logo-variant-red.svg";
import type { FC } from "react";

type TabsHeaderProps = {
  selectedSiteName: string | null;
  onHamburgerMenuPress: () => void;
  showLogo?: boolean;
  title?: string;
  headerShadowVisible?: boolean;
  showHamburgerMenu?: boolean;
};

export const TabsHeader: FC<TabsHeaderProps> = memo(
  ({
    selectedSiteName,
    onHamburgerMenuPress,
    showLogo = true,
    title,
    headerShadowVisible = false,
    showHamburgerMenu = true,
  }) => {
    const { theme } = useUnistyles();

    return (
      <View
        px="5xl"
        pb="xl"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        style={headerShadowVisible ? styles.headerShadow : undefined}
      >
        <View flexDirection="row" alignItems="center">
          {showLogo && <Logo width={124} height={32} color={theme.currentTheme === "dark" ? "#FFFFFF" : "#24255c"} />}
          {title && <Text textStyle="md/medium">{title}</Text>}
        </View>
        <View flexDirection="row" alignItems="center">
          <View flexDirection="row" alignItems="center" gap="xs" px="xl">
            <Icon name="building" size={20} color={theme.colors.text} />
            <Text textStyle="sm/regular">{selectedSiteName ?? "All sites"}</Text>
          </View>
          {showHamburgerMenu && (
            <Pressable onPress={onHamburgerMenuPress} style={styles.hamburgerMenuButton}>
              <Icon name="hamburgerMenu" size={20} color={theme.colors.text} />
            </Pressable>
          )}
        </View>
      </View>
    );
  },
);

TabsHeader.displayName = "TabsHeader";

const styles = StyleSheet.create((theme) => ({
  hamburgerMenuButton: {
    borderColor: theme.colors.interactive.buttons.default_background,
    borderWidth: 1,
    borderRadius: theme.spacing.md,
    height: 36,
    width: 36,
    alignItems: "center",
    justifyContent: "center",
  },
  headerShadow: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: theme.colors.border,
    ...Platform.select({
      android: {
        backgroundColor: theme.colors.background,
      },
      ios: {
        shadowOpacity: 0.3,
        shadowRadius: 0,
        shadowOffset: { width: 0, height: StyleSheet.hairlineWidth },
        shadowColor: theme.currentTheme === "dark" ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 1)",
      },
    }),
  },
}));
